var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m297.6 111.6v114h114v-114zm81.598 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 111.6h-114v114h114zm-33.602 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.2 111.6h-115.2v114h114v-114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.4 111.6h-114v114h114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.6 390h114v-114h-114zm32.398-81.602h49.199v49.199h-49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 274.8h-114v114h114zm-33.602 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.2 274.8h-115.2v114h114v-114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.4 274.8h-114v114h114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.6 553.2h114v-114h-114zm32.398-81.598h49.199v49.199h-49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 439.2h-114v114h114zm-33.602 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.2 439.2h-115.2v114h114v-114zm-32.398 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.4 439.2h-114v114h114zm-32.398 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.6 716.4h114v-114h-114zm32.398-81.598h49.199v49.199h-49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 602.4h-114v114h114zm-33.602 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.2 602.4h-115.2v114h114v-114zm-32.398 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.4 602.4h-114v114h114zm-32.398 81.602h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.6 879.6h114v-114h-114zm32.398-81.602h49.199v49.199h-49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576 765.6h-114v114h114zm-33.602 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m739.2 765.6h-115.2v114h114v-114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m902.4 765.6h-114v114h114zm-32.398 81.598h-49.199v-49.199h49.199z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m984 1137.6v-1107.6h-768v1107.6h-64.801v32.398h898.8v-32.398zm-735.6-1075.2h703.2v1075.2l-212.4 0.003906v-208.8h-278.4v208.8h-212.4zm367.2 898.8h90v175.2h-90zm-31.203 176.4h-90v-176.4h90z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding0);
export default __webpack_public_path__ + "static/media/building_0.b14db6e1624bf19dc0f64086e98637d8.svg";
export { ForwardRef as ReactComponent };